import script from "./MakesDB.vue?vue&type=script&setup=true&lang=js"
export * from "./MakesDB.vue?vue&type=script&setup=true&lang=js"

import "./MakesDB.vue?vue&type=style&index=0&id=72ac7d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ac7d52"]])

export default __exports__